// @flow
import {Map} from 'immutable';
import {Store, getStoreByName} from 'client/framework';
import scopeSelectorActions from './ScopeSelector.actions';

export default class ScopeSelectorStore extends Store {
  constructor(name) {
    super(name);
    this.initialData = new Map({
      scopeStoreNames: new Map()
    });

    this.setInitialData(this.initialData);
    this.handleTargeted(scopeSelectorActions.RECONFIGURE_SCOPE_SELECTOR, this._reconfigure);
  }

  _reconfigure(selectors: Set<string>) {
    const storeNames = selectors.reduce((result, selector) => {
      const storeName = `${this.getName()}-selector-${selector}`;
      return result.set(selector, storeName);
    }, new Map());

    this.writeData('scopeStoreNames', storeNames);
  }

  getStoreForSelector(selector: string): Store {
    const storeName = this.getStoreNameForSelector(selector);
    return getStoreByName(storeName);
  }

  getStoreNameForSelector(selector: string): string {
    return this.readData(['scopeStoreNames', selector]);
  }
}
